import { Component } from '@poa/core';
import { observable, Observer } from '@poa/state';
import moment from 'moment';
import React from 'react';
import DataTable from '../components/data-table/data-table';
import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';
import TableFilter, { PageMode } from '../components/table-filter';

class StatisticsPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa
  env; // injected by Poa

  localState = observable({
    pageMode: PageMode.statistics
  });

  onChangeDatesFines = async ({ startDate, endDate }) => {
    await this.actions.finesActions.setDates({ startDate, endDate });
    await this.actions.finesActions.refreshFines();
  };

  onPageModeChange = async event => {
    switch (event.target.value) {
      case PageMode.fines: {
        await this.actions.finesActions.setDates({
          startDate: this.store.statistics.filters.startDate,
          endDate: this.store.statistics.filters.endDate
        });

        this.localState.pageMode = PageMode.fines;

        if (this.store.fines.meta.loaded) {
          await this.actions.finesActions.refreshFines();
        } else {
          await this.actions.finesActions.fetchFines(this.startDate, this.endDate);
        }

        break;
      }
      case PageMode.statistics: {
        await this.actions.statisticsActions.setDates({
          startDate: this.store.statistics.filters.startDate,
          endDate: this.store.statistics.filters.endDate
        });

        this.localState.pageMode = PageMode.statistics;
        break;
      }
      default:
        console.error('Unknown page type', event.target.value);
        break;
    }
  };

  onCreateStat = async () => {
    const { startDate, endDate } = this.store.statistics.filters;
    let statInterval = null;
    try {
      this.localState.isTableLoading = true;
      const stats = await this.env.api.statistics.fetchStats(startDate, endDate);
      stats.loaded ? this.actions.statisticsActions.fetchStatsWaiting(stats.loaded) : this.actions.statisticsActions.fetchSuccess(stats.data);
      statInterval = stats.loaded ? stats.loaded : null;
    } catch (e) {
      console.error(e.response.data.error);
      this.env.alert('Ошибка', e.response.data.error, 'error');
    }

    if (statInterval) {
      setTimeout(this.onCreateStat, 3000);
    } else {
      this.localState.isTableLoading = false;
      this.store.statistics.meta.in_process = null;
    }
  };

  onChangeFilterFines = async filters => {
    this.lastFilters = filters;
    await this.actions.finesActions.refreshFines(filters, 1);
  };

  onPageChange = async page => {
    this.lastPage = page;
    await this.actions.finesActions.refreshFines(this.lastFilters, page);
  };

  saveColumnPreset = async preset => {
    await this.actions.statisticsActions.saveColumnPreset(preset);
  };

  render() {
    const { filters, selectors } = this.store.statistics;
    const {
      setDates,
      changeColumnPreset,
      changeColumnVisibility,
      changeSearch,
      toggleAllColumns,
      changePresetOrder,
      deletePreset
    } = this.actions.statisticsActions;

    switch (this.localState.pageMode) {
      case PageMode.fines: {
        const { filters, selectors, ui } = this.store.fines;
        const {
          changeGrouping,
          changeStatus,
          changeColumnPreset,
          changeColumnVisibility,
          changeSearch,
          changePresetOrder,
          deletePreset,
          toggleFavorite,
          toggleAllColumns
        } = this.actions.finesActions;

        const isDecimalThunk = () => filters.isDecimal;

        return (
          <RouteLoading
            key='1'
            meta={this.store.fines.meta}
            render={() => (
              <div className='content'>
                <Navbar />

                <div className='under-navbar-content'>
                  <TableFilter
                    state={filters}
                    selectors={selectors}
                    onDatesChange={this.onChangeDatesFines}
                    onGroupingChange={changeGrouping}
                    onStatusChange={changeStatus}
                    onColumnPresetChange={changeColumnPreset}
                    onColumnChange={changeColumnVisibility}
                    onColumnPresetSubmit={this.saveColumnPreset}
                    deletePreset={deletePreset}
                    onSearchChange={changeSearch}
                    withoutFractionalChange
                    withoutFilteringChange
                    withoutGroupingChange
                    withoutStatusChange
                    changePresetOrder={changePresetOrder}
                    onAllColumnsToggle={toggleAllColumns}
                    getTableNode={() => this.node}
                    onPageModeChange={this.onPageModeChange}
                    currentPageMode={this.localState.pageMode}
                  />
                  <div className='container finances-container small-container'>
                    <div className='inner'>
                      <div className='inner-scroll finances-table'>
                        <Observer>
                          {() =>
                            selectors.filteredData.map((table, idx) => (
                              <DataTable
                                ref={node => (this.node = node)}
                                sticky={true}
                                tableFiltersKey='fines-filters'
                                key={idx}
                                data={table}
                                columnSettings={filters.columnSettings}
                                favorites={ui.favorites}
                                toggleFavorite={toggleFavorite}
                                isDecimalThunk={isDecimalThunk}
                                requestModalOpen={this.onModalOpen}
                                isServerSide={!!table._meta}
                                onRemoveFilter={table._meta ? this.onChangeFilterFines : undefined}
                                onAddFilter={table._meta ? this.onChangeFilterFines : undefined}
                                currentPage={table._meta ? table._meta.page : undefined}
                                pageSize={table._meta ? table._meta.page_size : undefined}
                                pages={table._meta ? table._meta.pages : undefined}
                                onPageChange={table._meta ? this.onPageChange : undefined}
                                selectors={selectors}
                                valueMapper={({ headerId, data }) => {
                                  if (headerId === 'fine_time') {
                                    return moment(data.value * 1000).format('YYYY-MM-DD HH:mm');
                                  }

                                  return data.value;
                                }}
                                initialSortingMap={{ fine_time: 'desc' }}
                                account_filters={null}
                              />
                            ))
                          }
                        </Observer>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          />
        );
      }
      case PageMode.statistics: {

        let message = <div className='container' style={{
          width: '100%',
          margin: 'auto',
          background: 'aqua',
          padding: 30,
          'font-weight': 'bold',
          'text-align': 'center'
        }}> {this.store.statistics.meta.in_process} % already LOADED </div>;

        let wait_message = this.store.statistics.meta.in_process ? message : null;

        return (
          <RouteLoading
            key='2'
            meta={this.store.statistics.meta}>
            <div className='content'>
              <Navbar />

              <div className='under-navbar-content'>
                <TableFilter
                  state={filters}
                  selectors={selectors}
                  onDatesChange={setDates}
                  onColumnPresetChange={changeColumnPreset}
                  onColumnChange={changeColumnVisibility}
                  onColumnPresetSubmit={this.saveColumnPreset}
                  deletePreset={deletePreset}
                  onSearchChange={changeSearch}
                  changePresetOrder={changePresetOrder}
                  onAllColumnsToggle={toggleAllColumns}
                  withoutFractionalChange
                  withoutFilteringChange
                  withoutStatusChange
                  withoutGroupingChange
                  getTableNode={() => this.node}
                  onPageModeChange={this.onPageModeChange}
                  currentPageMode={this.localState.pageMode}
                  render={() => <div style={{ verticalAlign: 'middle' }}>
                    <button type='button' className='report_button' onClick={this.onCreateStat}>
                      СТАТИСТИКА
                    </button>
                  </div>}
                />
                {wait_message}
                <div className='container finances-container small-container'>
                  <div className='inner'>
                    <div className='inner-scroll finances-table'>
                      <Observer>
                        {() =>
                          selectors.filteredData.map((table, idx) => (
                            <DataTable
                              sticky={true}
                              tableFiltersKey='statistics-filters'
                              ref={node => (this.node = node)}
                              key={idx}
                              data={table}
                              isDecimalThunk={() => true}
                              columnSettings={filters.columnSettings}
                              selectors={selectors}
                              account_filters={null}
                            />
                          ))
                        }
                      </Observer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </RouteLoading>
        );
      }
      default:
        return null;
    }
  }
}

export default Component({ namespaces: ['statistics'] })(StatisticsPage);
